import { Box, AspectRatio, Flex, Text } from '@chakra-ui/react'
import Image from 'next/image'

const Item = ({
  src,
  alt,
  haveNewIcon = false
}: {
  src: any
  alt: string
  haveNewIcon?: boolean
}) => {
  return (
    <Box position="relative" zIndex={100}>
      {haveNewIcon && (
        <Box position="absolute" zIndex={10}>
          <AspectRatio
            w={{
              base: '50px',
              md: '80px'
            }}
            ratio={1 / 1}
            position="relative"
          >
            <Image
              src={
                'https://habbit-sg.s3.ap-southeast-1.amazonaws.com/hero-new-1714039687154.png'
              }
              alt="new icon"
              fill
            />
          </AspectRatio>
        </Box>
      )}

      <AspectRatio
        w={{
          base: '80px',
          md: '100px',
          lg: '120px'
        }}
        ratio={296 / 960}
        position="relative"
      >
        <Image src={src} alt={alt} fill />
      </AspectRatio>
    </Box>
  )
}

const ThreeBottle = ({ isHero = true }: { isHero?: boolean }) => {
  return (
    <Flex
      w={{
        base: 300,
        sm: 400,
        md: 400,
        lg: 480
      }}
      justifyContent="center"
      flexDir="column"
      alignItems="center"
      position="relative"
    >
      <Flex w="400" gap={1}>
        <Item
          src={
            'https://habbit-sg.s3.ap-southeast-1.amazonaws.com/bottle-01-1715151284730.png'
          }
          alt="green tea"
          haveNewIcon
        />
        <Item
          src={
            'https://habbit-sg.s3.ap-southeast-1.amazonaws.com/bottle-02-1715151284733.png'
          }
          alt="black tea"
          haveNewIcon
        />
        <Item
          src={
            'https://habbit-sg.s3.ap-southeast-1.amazonaws.com/bottle-03-1715151284733.png'
          }
          alt="ginseng tea"
        />
      </Flex>
      {isHero && (
        <Flex
          w={{
            base: '110px',
            md: '120px',
            lg: '140px'
          }}
          h={{
            base: '110px',
            md: '120px',
            lg: '140px'
          }}
          position="absolute"
          top="-40px"
          right={{
            base: '10px',
            md: '-10px'
          }}
          zIndex={100}
          bgColor="#9cb259"
          borderRadius="9999px"
          justifyContent="center"
          alignItems="center"
          flexDir="column"
        >
          <Text
            textStyle="oralcareFeaTittleLarge"
            textAlign="center"
            fontWeight={700}
            w={{
              base: '90%',
              sm: '80%'
            }}
            zIndex={100}
          >
            Easy Gargle Formula
          </Text>
          <Text
            textStyle="oralcareFeaTittle"
            textAlign="center"
            fontWeight={400}
            w={{
              base: '90%',
              sm: '80%'
            }}
            zIndex={100}
          >
            No more burning sensation
          </Text>
        </Flex>
      )}
      <AspectRatio
        w={{
          base: 300,
          md: 360,
          lg: 400,
          xl: 400
        }}
        ratio={1537 / 551}
        position="relative"
        mt={{
          base: '-60px',
          md: '-60px',
          lg: '-80px'
        }}
        zIndex={10}
      >
        <Image
          src={
            'https://habbit-sg.s3.ap-southeast-1.amazonaws.com/opacity-1714039687155.png'
          }
          alt="opacoty"
          fill
        />
      </AspectRatio>
    </Flex>
  )
}
export default ThreeBottle
